import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Radio from '_components/radio-input'

import './styles.scss'

const RadioGroup = (props) => {
  const { onChange, options, radioClassName, className, groupName } = props

  return (
    <div className={classNames('st-radio-group__container', className)}>
      <For each="option" of={options}>
        <React.Fragment key={option.label}>
          <Radio
            name={groupName}
            label={option.label}
            onChange={onChange}
            checked={option.checked}
            disabled={option.disabled}
            className={radioClassName}
            title={option.title}
          />
        </React.Fragment>
      </For>
    </div>
  )
}

RadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      checked: PropTypes.bool,
      disabled: PropTypes.bool,
      title: PropTypes.string,
    })
  ).isRequired,
  groupName: PropTypes.string.isRequired,
  className: PropTypes.string,
  radioClassName: PropTypes.string,
}

RadioGroup.defaultProps = {
  options: [],
}

export default RadioGroup
